export default __webpack_public_path__ + "static/media/efecto-3.fc7b6c97.webp";